import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

const STATUS_LABELS: Record<StatusPagamentoEnum, string> = {
  [StatusPagamentoEnum.paid]: "PAGO",
  [StatusPagamentoEnum.pending]: "PENDENTE",
  [StatusPagamentoEnum.canceled]: "CANCELADO",
  [StatusPagamentoEnum.refunded]: "REEMBOLSADO",
  [StatusPagamentoEnum.expired]: "EXPIRADO",
};

export function getStatusLabel(status: StatusPagamentoEnum) {
  return STATUS_LABELS[status] ?? status;
}
